<div *ngIf="label; else noLabel" class="c-overview-details-grid__label">
  <span>{{label}}</span>
  <span *ngIf="isEditing && mandatory" class="text-alert">&nbsp;*</span>
</div>

<ng-template #noLabel> <!-- using nbsp to take up space so things are aligned -->
  <div *ngIf="!isSubField" class="c-overview-details-grid__label">&nbsp;</div>
</ng-template>
